// -----------------------------------------------------------
// @ ExpenseType Actions
// -----------------------------------------------------------

import { createAction, props } from '@ngrx/store';

// Load all ExpenseTypes
export const loadExpenseTypes = createAction(
    '[ExpenseType] Load Expense Types'
);
export const loadExpenseTypesSuccess = createAction(
    '[ExpenseType] Load Expense Types Success',
    props<{ expenseTypes: any[] }>()
);
export const loadExpenseTypesFailure = createAction(
    '[ExpenseType] Load Expense Types Failure',
    props<{ error: string }>()
);

// Load single ExpenseType
export const loadExpenseType = createAction(
    '[ExpenseType] Load Expense Type',
    props<{ id: number }>()
);
export const loadExpenseTypeSuccess = createAction(
    '[ExpenseType] Load Expense Type Success',
    props<{ expenseType: any }>()
);
export const loadExpenseTypeFailure = createAction(
    '[ExpenseType] Load Expense Type Failure',
    props<{ error: string }>()
);

// Create
export const createExpenseType = createAction(
    '[ExpenseType] Create Expense Type',
    props<{ data: string }>()
);
export const createExpenseTypeSuccess = createAction(
    '[ExpenseType] Create Expense Type Success',
    props<{ expenseType: any; success: string }>()
);
export const createExpenseTypeFailure = createAction(
    '[ExpenseType] Create Expense Type Failure',
    props<{ error: string }>()
);

// Update
export const updateExpenseType = createAction(
    '[ExpenseType] Update Expense Type',
    props<{ data: string; id: number }>()
);
export const updateExpenseTypeSuccess = createAction(
    '[ExpenseType] Update Expense Type Success',
    props<{ expenseType: any; success: string }>()
);
export const updateExpenseTypeFailure = createAction(
    '[ExpenseType] Update Expense Type Failure',
    props<{ error: string }>()
);

// Delete
export const deleteExpenseType = createAction(
    '[ExpenseType] Delete Expense Type',
    props<{ id: number }>()
);
export const deleteExpenseTypeSuccess = createAction(
    '[ExpenseType] Delete Expense Type Success',
    props<{ id: number; success: string }>()
);
export const deleteExpenseTypeFailure = createAction(
    '[ExpenseType] Delete Expense Type Failure',
    props<{ error: string }>()
);
